import { z } from 'zod';
export const StatusSchema = z.enum(['pending', 'created', 'sent', 'deleted', 'paymentMade']);
export const StatusEnum = StatusSchema.enum;
